// Disabling this to remove warnings in lints. only affects dev mode with this file.
/* eslint-disable react-refresh/only-export-components */
import type { TileStatus } from "@qoTypes/dragon-tiles";
import type { JSX } from "react";

export const STATUS_COLOR_MAP: Record<TileStatus, string> = {
  Off: "#F5F2F8",
  Active: "#F4289D",
  Running: "#F4289D",
  "Needs Attention": "#FBF2CA",
};

export const TILE_VARIANTS = {
  large: { width: 215, height: 240, nameFontSize: 20, statusFontSize: 13 },
  medium: { width: 160, height: 180, nameFontSize: 15, statusFontSize: 10 },
  extraLarge: { width: 700, height: 800, nameFontSize: 20, statusFontSize: 13 },
};

export const TILE_ICON_MAP: Record<
  string,
  (strokeColor: string) => JSX.Element
> = {
  Discover: (strokeColor: string) => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1245 1.90039C10.1245 1.90039 8.31286 6.83714 10.1245 10.0004C11.9362 13.1636 10.1245 18.1004 10.1245 18.1004"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M13.3799 1.90039V18.1004"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M15.8291 1.90039V18.1004"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M18.2783 1.90039V18.1004"
        stroke="#252327"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M6.87012 1.90039V18.1004"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M4.4209 1.90039V18.1004"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M1.97168 1.90039V18.1004"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  Magic: (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M10.1218 1.90234V18.1023M18.2244 9.9993L2.02441 9.99929M15.8547 15.7278L4.39953 4.27264M4.39944 15.7321L15.8546 4.27693"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  Cart: (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M2.08398 2.05469H18.1667"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.08398 5.06641H18.1667"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.08398 7.79102H18.1667"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.58398 10.498H17.6667"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M3.08398 13.0215H17.1667"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M4.08398 15.5215H16.1667"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M6.83887 17.6582H13.4111"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  Browse: (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <circle
        cx="10.125"
        cy="11.5391"
        r="2.44844"
        stroke={strokeColor}
        strokeWidth="1.4"
      />
      <path
        d="M10.125 4.26836V3.06836"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M13.9725 5.01867L14.4414 3.91406"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M17.3043 7.049L17.9043 6.00977"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M6.27082 5.02082L5.82129 3.9082"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.9457 7.049L2.3457 6.00977"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M1.73242 11.6242C3.24791 8.32607 11.6158 1.9816 18.5166 11.6242C15.6435 15.9781 8.5722 20.1394 1.73242 11.6242Z"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  "New Subscriber": (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M4.82324 15.2257C5.77695 12.8866 11.5955 10.3323 15.3857 15.2257"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M9.81229 5.13086C9.81229 5.13086 9.27003 6.63931 9.81229 7.60586C10.3546 8.57241 9.81229 10.0809 9.81229 10.0809"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M6.47159 6.8407C6.47159 6.8407 6.32536 8.17469 7.06771 8.68652C7.81007 9.19834 7.66384 10.5323 7.66384 10.5323"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M13.1532 6.84094C13.1532 6.84094 12.2803 7.75691 12.5571 8.68676C12.8339 9.61661 11.961 10.5326 11.961 10.5326"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.82915 7.55198C2.82915 7.55198 3.27413 9.10034 4.24081 9.44794C5.20749 9.79555 5.65246 11.3439 5.65246 11.3439"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M16.9942 7.55154C16.9942 7.55154 15.7184 8.31427 15.5825 9.4475C15.4466 10.5807 14.1709 11.3435 14.1709 11.3435"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M1.19232 10.6102C1.19232 10.6102 1.69557 11.8288 2.56579 11.8195C3.43602 11.8102 3.93927 13.0288 3.93927 13.0288"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M18.7802 10.6105C18.7802 10.6105 17.6093 10.866 17.4067 11.8198C17.2042 12.7737 16.0333 13.0292 16.0333 13.0292"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  Broadcast: (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M1.75977 7.27539C1.75977 7.27539 4.13199 8.72353 5.94263 8.72353C7.75326 8.72353 8.31486 7.27539 10.1255 7.27539C11.9361 7.27539 12.4977 8.72353 14.3083 8.72353C16.119 8.72353 18.4912 7.27539 18.4912 7.27539"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M1.75977 11.2754C1.75977 11.2754 4.13199 12.7235 5.94263 12.7235C7.75326 12.7235 8.31486 11.2754 10.1255 11.2754C11.9361 11.2754 12.4977 12.7235 14.3083 12.7235C16.119 12.7235 18.4912 11.2754 18.4912 11.2754"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M1.75977 15.2754C1.75977 15.2754 4.13199 16.7235 5.94263 16.7235C7.75326 16.7235 8.31486 15.2754 10.1255 15.2754C11.9361 15.2754 12.4977 16.7235 14.3083 16.7235C16.119 16.7235 18.4912 15.2754 18.4912 15.2754"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M1.75977 3.27539C1.75977 3.27539 4.13199 4.72353 5.94263 4.72353C7.75326 4.72353 8.31486 3.27539 10.1255 3.27539C11.9361 3.27539 12.4977 4.72353 14.3083 4.72353C16.119 4.72353 18.4912 3.27539 18.4912 3.27539"
        stroke={strokeColor}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  ),
  "Price Drop": (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M8.12483 1.90039C8.12483 1.90039 3.82731 5.70249 8.12483 10.0004C12.4223 14.2983 8.12483 18.1004 8.12483 18.1004"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M12.1248 1.90039C12.1248 1.90039 7.82731 5.70249 12.1248 10.0004C16.4223 14.2983 12.1248 18.1004 12.1248 18.1004"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M16.1248 1.90039C16.1248 1.90039 11.8273 5.70249 16.1248 10.0004C20.4223 14.2983 16.1248 18.1004 16.1248 18.1004"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M4.12483 1.90039C4.12483 1.90039 -0.172687 5.70249 4.12483 10.0004C8.42234 14.2983 4.12483 18.1004 4.12483 18.1004"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M3.81348 15.2617L4.125 18.0996"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M16.4355 5.0918L16.125 1.90039"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  "Low Stock": (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M13.9504 10.0051C6.4052 10.8465 6.52423 17.6608 9.8331 18.0663C10.8243 18.1719 11.7621 17.817 11.6529 16.6793C11.5081 15.453 10.4776 15.3285 10.1041 15.4841"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M13.9504 10.0008C6.4052 9.15933 6.52423 2.34502 9.8331 1.93961C10.8243 1.83399 11.7621 2.18885 11.6529 3.32653C11.5081 4.55287 10.4776 4.67733 10.1041 4.52176"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  "Back in Stock": (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M6.98906 10.0051C14.5343 10.8465 14.4152 17.6608 11.1064 18.0663C10.1151 18.1719 9.17733 17.817 9.28652 16.6793C9.43132 15.453 10.4619 15.3285 10.8354 15.4841"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M6.98906 10.0008C14.5343 9.15933 14.4152 2.34502 11.1064 1.93961C10.1151 1.83399 9.17733 2.18885 9.28652 3.32653C9.43132 4.55287 10.4619 4.67733 10.8354 4.52176"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  "New Arrivals": (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M9.87587 1.9082C9.87587 1.9082 9.37734 2.90441 9.87587 3.54274C10.3744 4.18106 9.87587 5.17727 9.87587 5.17727"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <circle
        cx="10.1374"
        cy="10.0017"
        r="2.23918"
        stroke={strokeColor}
        strokeWidth="1.4"
      />
      <path
        d="M10.4083 18.0918C10.4083 18.0918 10.9068 17.0956 10.4083 16.4573C9.90978 15.8189 10.4083 14.8227 10.4083 14.8227"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M15.6596 4.09613C15.6596 4.09613 14.6027 4.44804 14.5038 5.25192C14.405 6.0558 13.348 6.40771 13.348 6.40771"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M4.59235 15.9136C4.59235 15.9136 5.64929 15.5617 5.74814 14.7578C5.84699 13.954 6.90393 13.6021 6.90393 13.6021"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M18.2168 9.73719C18.2168 9.73719 17.2206 9.23866 16.5823 9.73719C15.9439 10.2357 14.9477 9.73719 14.9477 9.73719"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.0332 10.2726C2.0332 10.2726 3.02941 10.7711 3.66774 10.2726C4.30606 9.77404 5.30227 10.2726 5.30227 10.2726"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M16.0318 15.5375C16.0318 15.5375 15.6799 14.4806 14.876 14.3817C14.0721 14.2829 13.7202 13.226 13.7202 13.226"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M4.21136 4.47223C4.21136 4.47223 4.56327 5.52917 5.36715 5.62802C6.17103 5.72687 6.52294 6.78381 6.52294 6.78381"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  "Post Purchase": (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M2.5332 2.54102C9.30331 2.70501 23.0001 3.78903 15.5681 5.30426C6.00149 7.25472 -0.558385 8.1916 5.7155 8.911C11.7492 9.60287 20.9369 9.52279 12.7846 11.7824C3.34011 13.9651 2.92169 14.0961 9.67864 14.7866C14.0898 15.347 16.1542 16.7498 8.84065 17.4463"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  Rebuy: (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M10.239 7.14428C7.34641 5.85039 5.08924 9.47709 7.42297 11.5498C12.4288 15.5692 18.9029 5.94802 10.5443 3.21711C0.66142 -0.0117818 -1.92918 18.1561 11.0288 17.1269C12.7833 16.9302 16.643 15.6084 18.0459 11.8948"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  Compare: (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M2.06348 6.76892C2.06348 6.76892 5.8477 11.0462 10.1254 6.76892C14.4031 2.49162 18.1873 6.76892 18.1873 6.76892"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.06348 12.7396C2.06348 12.7396 5.8477 17.0169 10.1254 12.7396C14.4031 8.46232 18.1873 12.7396 18.1873 12.7396"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  "Cross Sell": (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M7.05066 18.2754C7.05066 18.2754 5.71289 15.0242 9.09911 12.0664C15.854 6.84703 8.09911 1.76045 8.09911 1.76045"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M13.1993 18.2402C13.1993 18.2402 14.5371 14.989 11.1509 12.0313C4.396 6.81187 12.1509 1.7253 12.1509 1.7253"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  Upsell: (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M2.35938 18.4596L10.0859 13.2285L17.8914 18.6073"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.35938 15.6276L10.0859 10.3965L17.8914 15.7753"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.35938 12.7956L10.0859 7.56445L17.8914 12.9432"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.35938 9.96353L10.0859 4.73242L17.8914 10.1112"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.35938 7.1315L10.0859 1.90039L17.8914 7.27916"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  Subscribe: (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M18.4084 1.90039C18.3262 3.27463 16.3135 6.02312 8.91957 6.02312C1.52566 6.02312 1.2655 4.73476 2.05966 4.09058C5.55774 1.66764 17.0257 2.32678 18.4494 6.92499C19.0203 9.18187 14.3827 11.649 9.00163 11.5202C6.81085 11.4916 2.30606 11.1251 1.81313 9.88825C1.32021 8.65141 6.26316 8.28494 8.79625 8.25631C11.7264 8.28494 17.7593 9.2097 18.4494 12.6797C18.6137 15.2565 12.5415 16.7568 9.08379 16.7596C6.92039 16.8311 2.47908 16.5362 1.93637 15.2994C1.41058 13.9595 6.45485 13.6818 9.04271 13.7104C12.0276 13.8106 18.0715 14.8184 18.3672 18.0479"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  "Category Story": (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <circle
        cx="5.24023"
        cy="5.5"
        r="2.86836"
        stroke={strokeColor}
        strokeWidth="1.4"
      />
      <path
        d="M11.8691 5.37305H18.1494"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M11.8691 2.51172H18.1494"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M11.8691 8.23047H18.1494"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <circle
        cx="15.0098"
        cy="14.5"
        r="2.86836"
        stroke={strokeColor}
        strokeWidth="1.4"
      />
      <circle
        cx="5.24023"
        cy="14.5"
        r="2.86836"
        stroke={strokeColor}
        strokeWidth="1.4"
      />
    </svg>
  ),
  "Brand Story": (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <path
        d="M2.8457 7.33811C2.8457 7.33811 7.28196 5.33811 10.1245 7.33811C12.9671 9.33811 17.4033 7.33811 17.4033 7.33811"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.8457 2.01953H10.1256"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.8457 12.6602H17.4033"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.8457 17.9805H17.4033"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
  "Product Story": (strokeColor: string) => (
    <svg width="32" height="32" viewBox="0 0 20 20" fill="none">
      <circle
        cx="5.24023"
        cy="5.5"
        r="2.86836"
        stroke={strokeColor}
        strokeWidth="1.4"
      />
      <path
        d="M11.8691 5.37305H18.1494"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M11.8691 2.51172H18.1494"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M11.8691 8.23047H18.1494"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <circle
        cx="15.0098"
        cy="14.5"
        r="2.86836"
        stroke={strokeColor}
        strokeWidth="1.4"
      />
      <path
        d="M2.09961 14.373H8.37988"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.09961 11.5117H8.37988"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      <path
        d="M2.09961 17.2305H8.37988"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  ),
} as const satisfies Record<string, (strokeColor: string) => JSX.Element>;
